import React, {FC, useEffect, useState} from "react"
import PropTypes from "prop-types"

import {Body, H1, Label} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage, useIntl} from "@irati/utils/lang"
import tracking from "@irati-tracking/perks/perks"
import checkoutService from "@irati/checkout/services/checkout"
import {Checkout, Deal} from "@irati/types"
import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import Loading from "@irati/ui/src/Loading"
import {Col} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"
import Link from "@irati/ui/src/Link"
import Button from "@irati/ui/src/Button"
import Spacing from "@irati/ui/src/Spacing"
import redemptionFlow from "@irati/checkout/utils/redemption"
import detailsToWebAddress from "@irati/checkout/utils/redemption/helpers/detailsToWebAddress"
import history from "@irati/utils/history"
import {hangPromise} from "@irati/utils/promise"

interface Props extends WithAuth {
  deal: Deal
}

const CheckoutFlexiRedemptions: FC<Props> = ({deal, auth}, context) => {
  const [checkout, setCheckout] = useState<Checkout>()
  const [load, setLoad] = useState<Promise<any>>()
  const [submitLoad, setSubmitLoad] = useState<Promise<any>>()
  const {formatMessage} = useIntl()

  useEffect(() => {
    const startCheckout = async () => {
      const request = checkoutService.startCheckout(auth.user.uuid)
      setLoad(request)
      const res = await request
      tracking.redeemPerkStartCheckout(deal)
      setCheckout(res)
    }
    startCheckout()
  }, [])

  const handleSubmit = () => {
    const req = redemptionFlow.paymentComplete(deal, checkout.uuid, checkout.paymentOrder.uuid).then((details) => {
      const url = detailsToWebAddress(details)
      history.push(url, context)
      return hangPromise()
    })
    setSubmitLoad(req)
  }

  const termsLink =
    auth.user.regionId === "AU" ? "perks.checkout.termsAndConditions.linkHrefAu" : "perks.checkout.termsAndConditions.linkHref"

  return (
    <Loading load={load} initLoad>
      <H1>
        <FormattedMessage id="perks.checkout.header" />
      </H1>
      <Col mdHidden lgHidden>
        <Flex justifyContent="space-between" alignItems="center" marginTop>
          <Body large>
            <FormattedMessage id="perks.components.orderSummary.total.toPay" />
          </Body>
          <Flex alignItems="center">
            <Body large marginLeft>
              <FormattedCurrency value={checkout?.basket?.total?.amount} currency={checkout?.basket?.total?.currency} />
            </Body>
          </Flex>
        </Flex>
      </Col>
      <Spacing marginTop>
        <Label color={mainTheme.colors.greys.grey50}>
          <FormattedMessage
            id="perks.checkout.termsAndConditions.copy"
            values={{
              link: (
                <Link plain href={formatMessage({id: termsLink})}>
                  <FormattedMessage id="perks.checkout.termsAndConditions.linkCopy" />
                </Link>
              )
            }}
          />
        </Label>
      </Spacing>
      <Button primary full marginTop={2} load={submitLoad} onClick={handleSubmit}>
        <FormattedMessage id="perks.checkout.payWithPoints" />
      </Button>
      <Loading load={submitLoad} useLoader={false} />
    </Loading>
  )
}

CheckoutFlexiRedemptions.contextTypes = {
  appPath: PropTypes.string
}

export default withAuth(CheckoutFlexiRedemptions)
